import React from 'react';
import { Popover } from '@mui/material';

export default function NotificationPopover(props) {
    const {anchorEl, open, handleClose, content} = props

    const id = open ? 'simple-popover' : undefined;
  
    return (
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          sx={{
            '& .MuiPaper-root': {
              backgroundColor: 'transparent', // Make the background transparent
              boxShadow: 'none', // Remove the box shadow
            },
          }}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <div
            style={{
              background: '#282828',
              color: 'white',
              padding: '16px',
            //   border: '2px solid rgba(107,164,125,1)',
              borderRadius: '6px',    
            }}
          >
            {content}
          </div>
        </Popover>
    );
}